import React from 'react';
import { BsChevronDoubleLeft, BsChevronLeft } from 'react-icons/bs';
import { Flex, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function BackIconGroup({ calendars, getBackProps }) {
  return (
    <Flex>
      <Tooltip hasArrow label="Previous year">
        <IconButton
          {...getBackProps({ calendars, offset: 12 })}
          icon={<Icon as={BsChevronDoubleLeft} />}
          variant="textPrimary"
        />
      </Tooltip>
      <Tooltip hasArrow label="Previous month">
        <IconButton
          {...getBackProps({ calendars })}
          icon={<Icon as={BsChevronLeft} />}
          variant="textPrimary"
        />
      </Tooltip>
    </Flex>
  );
}

BackIconGroup.propTypes = {
  calendars: PropTypes.arrayOf(PropTypes.shape({})),
  getBackProps: PropTypes.func
};

export default BackIconGroup;
